import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEOTemplate from '../components/SEOTemplate';
import { handleAnchorClick } from '../utils/scrollUtils';

// 導入服務相關圖片
import 網站設計圖片 from '../assets/images/web-1738168_1280.jpg';
import 行動應用圖片 from '../assets/images/telephone-4115290_1280.jpg';
import 數位行銷圖片 from '../assets/images/books-1655783_1280.jpg';
import 企業解決方案圖片 from '../assets/images/erp-8012424_1280.jpg';
import 電子商務圖片 from '../assets/images/e-commerce-3406613_1280.jpg';
import 數據分析圖片 from '../assets/images/office-2717014_1280.jpg';

const Services = () => {
  const { t } = useTranslation();

  // 服務詳細資料
  const servicesList = [
    {
      id: 1,
      title: '網站設計與開發',
      description: '我們提供專業的網站設計與開發服務，從簡單的企業形象網站到複雜的網頁應用程式，我們的團隊都能為您打造符合需求的解決方案。我們注重使用者體驗、響應式設計和搜尋引擎最佳化，確保您的網站不僅美觀，更能有效地吸引和轉換訪客。',
      image: 網站設計圖片,
      features: [
        '響應式網站設計，適應各種裝置',
        '使用者體驗設計與優化',
        '搜尋引擎最佳化 (SEO)',
        '網站效能優化',
        '內容管理系統 (CMS) 整合',
        '網站維護與支援服務'
      ],
      icon: 'fa-laptop-code'
    },
    {
      id: 2,
      title: '行動應用程式開發',
      description: '我們的行動應用開發團隊擅長打造原生和跨平台應用程式，幫助企業拓展行動通路，增強與客戶的互動。從應用程式概念到設計、開發、測試和上架，我們提供全方位的服務，確保您的應用程式符合市場需求並提供卓越的用戶體驗。',
      image: 行動應用圖片,
      features: [
        'iOS 和 Android 原生應用開發',
        'React Native 跨平台應用開發',
        '行動應用設計與使用者體驗優化',
        '應用程式功能與性能測試',
        'App Store 和 Google Play 上架服務',
        '應用程式更新與維護'
      ],
      icon: 'fa-mobile-alt'
    },
    {
      id: 3,
      title: '數位行銷策略',
      description: '我們提供全方位的數位行銷服務，幫助企業建立品牌知名度，吸引目標客群，並提高轉換率。我們根據您的業務目標和市場定位，制定客製化的數位行銷策略，並透過數據分析持續優化行銷效果，為您創造最大的投資回報。',
      image: 數位行銷圖片,
      features: [
        '搜尋引擎行銷 (SEM) 與關鍵字廣告',
        '社群媒體行銷與管理',
        '內容行銷策略與執行',
        '電子郵件行銷活動',
        '轉換率優化 (CRO)',
        '數位行銷數據分析與報告'
      ],
      icon: 'fa-chart-line'
    },
    {
      id: 4,
      title: '系統整合與企業解決方案',
      description: '我們協助企業整合各種系統和應用程式，提高營運效率並簡化流程。我們的企業解決方案涵蓋客戶關係管理、企業資源規劃、供應鏈管理等多個領域，為企業數位轉型提供全面支援，創造更高的業務價值。',
      image: 企業解決方案圖片,
      features: [
        '企業資源規劃 (ERP) 系統開發',
        '客戶關係管理 (CRM) 系統整合',
        'API 開發與系統整合',
        '雲端服務與架構設計',
        '資料庫設計與優化',
        '企業工作流程自動化'
      ],
      icon: 'fa-cogs'
    },
    {
      id: 5,
      title: '電子商務解決方案',
      description: '我們提供完整的電子商務解決方案，從網站建置、產品管理、付款處理到訂單履行，我們都能為您打造符合需求的電商平台。我們的解決方案注重使用者體驗、安全性和可擴充性，幫助您的電商業務蓬勃發展。',
      image: 電子商務圖片,
      features: [
        '電子商務網站設計與開發',
        '多種支付閘道整合',
        '庫存與訂單管理系統',
        '會員系統與客戶忠誠度計劃',
        '產品推薦與個人化功能',
        '電商行銷與分析工具整合'
      ],
      icon: 'fa-shopping-cart'
    },
    {
      id: 6,
      title: '數據分析與視覺化',
      description: '我們協助企業收集、分析和視覺化數據，從中獲取有價值的洞見，支援決策制定。我們的數據分析服務涵蓋數據收集、清理、分析到視覺化呈現，為您提供全面的數據支援，幫助您更好地理解業務運營和客戶行為。',
      image: 數據分析圖片,
      features: [
        '商業智慧 (BI) 儀表板開發',
        '數據收集與整合',
        '數據分析與洞見挖掘',
        '預測分析與機器學習應用',
        '自定義報表與視覺化',
        '數據策略與數據治理諮詢'
      ],
      icon: 'fa-chart-pie'
    }
  ];

  return (
    <>
      <SEOTemplate pageType="services" />
      
      {/* 頁面標題 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1 className="display-4">{t('ourServices')}</h1>
              <p className="lead">凱撒數位科技提供全方位的數位服務，助您在數位時代保持競爭力</p>
            </div>
          </div>
        </div>
      </section>

      {/* 服務簡介 */}
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center mb-5">
              <h2>我們能為您做什麼</h2>
              <p className="lead">
                凱撒數位科技提供從網站開發、行動應用到企業系統整合的全方位數位服務。
                無論您是尋求建立全新的數位形象，還是優化現有系統，我們都能為您量身打造最適合的解決方案。
              </p>
            </div>
          </div>

          {/* 服務卡片 */}
          <div className="row">
            {servicesList.slice(0, 4).map(service => (
              <div className="col-md-6 mb-4" key={service.id}>
                <div className="card h-100 border-0 shadow">
                  <div className="card-body p-4">
                    <div className="d-flex align-items-center mb-4">
                      <i className={`fas ${service.icon} fa-2x text-primary mr-3`}></i>
                      <h3 className="card-title mb-0">{service.title}</h3>
                    </div>
                    <p className="card-text">{service.description.substring(0, 150)}...</p>
                    <a 
                      href={`#service-${service.id}`} 
                      className="btn btn-outline-primary"
                      onClick={handleAnchorClick(`service-${service.id}`)}
                    >
                      了解更多
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 服務詳情區段 */}
      {servicesList.map((service, index) => (
        <section 
          id={`service-${service.id}`} 
          className={`py-5 ${index % 2 === 1 ? 'bg-light' : ''}`}
          key={service.id}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className={`col-lg-6 mb-4 mb-lg-0 ${index % 2 === 1 ? 'order-lg-2' : ''}`}>
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="img-fluid rounded shadow"
                />
              </div>
              <div className={`col-lg-6 ${index % 2 === 1 ? 'order-lg-1' : ''}`}>
                <h2 className="mb-4">{service.title}</h2>
                <p>{service.description}</p>
                <h4 className="mt-4 mb-3">主要服務內容</h4>
                <ul className="list-unstyled">
                  {service.features.map((feature, idx) => (
                    <li className="mb-2" key={idx}>
                      <i className="fas fa-check-circle text-success mr-2"></i> {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* 服務流程 */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h2>我們的服務流程</h2>
            <p>我們遵循結構化的流程，確保每個專案都能達到最佳成果</p>
          </div>

          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card h-100 border-0 shadow">
                <div className="card-body text-center p-4">
                  <div className="display-4 text-primary mb-3">01</div>
                  <h3>需求分析與規劃</h3>
                  <p>
                    我們深入了解您的業務需求和目標，分析市場趨勢和競爭環境，
                    制定全面的專案計畫，確保解決方案符合您的期望。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 border-0 shadow">
                <div className="card-body text-center p-4">
                  <div className="display-4 text-primary mb-3">02</div>
                  <h3>設計與開發</h3>
                  <p>
                    我們的團隊運用先進技術和最佳實踐，進行設計和開發工作，
                    在整個過程中與您保持密切溝通，確保產品符合您的需求。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="card h-100 border-0 shadow">
                <div className="card-body text-center p-4">
                  <div className="display-4 text-primary mb-3">03</div>
                  <h3>測試與上線</h3>
                  <p>
                    我們進行全面的測試，確保產品的穩定性和安全性，
                    然後協助您順利上線，並提供後續的維護和支援服務。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 聯絡我們 CTA */}
      <section className="py-5 bg-primary text-white text-center">
        <div className="container">
          <h2 className="mb-4">準備好開始您的數位轉型之旅了嗎？</h2>
          <p className="lead mb-4">聯絡我們，讓我們一起討論如何為您的企業打造最佳的數位解決方案</p>
          <Link to="/contact" className="btn btn-light btn-lg">
            立即聯絡我們
          </Link>
        </div>
      </section>
    </>
  );
};

export default Services;
